// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.home {
    margin: 0;
    display: grid;
    /* grid-template-areas: "left left left . center center center center center . right right"; */
    grid-template-areas: "left left left center center center center right right right";
    grid-template-columns: repeat(10, 1fr);
    gap: 70px;
    padding-top: var(--space-and-half);
}

.home__left-container {
    grid-area: left;
    /* padding-left: var(--space-and-half); */
    padding: 18px var(--space);
    height: calc(100% - 70px);
    background: var(--white-color);
    overflow:auto;
    overflow:overlay;
    /* border-radius: 12px; */
    /* border-bottom: 20px solid var(--white-color); */
    position: fixed;
    width: 27%;
    top: 70px;
}

.home__left-container::-webkit-scrollbar {
    display: none; 
}

.home__left-container:hover::-webkit-scrollbar {
    display: initial;
}

.home__left-container::-webkit-scrollbar:vertical {
    width:10px;
}

.home__left-container::-webkit-scrollbar:horizontal {
    height: 10px;
}

.home__left-container::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.home__left-container.gphome{
    grid-column-start: 1;
    grid-column-end: 3;
    padding-left: 0;
    position: fixed;
    width: 17%;
    /* overflow: initial; */
}

.home__right-container {
    grid-area: right;
    padding-right: var(--space-and-half);
}
.home__right-container__title {
    margin-top: var(--space-x3);
}
.home__right-container__subtitle {
    margin-top: var(--space-x2);
}
.home__right-container__profile-suggestions {
    margin-top: var(--space-x2);
}
.home__right-container__pages-suggestions {
    /* margin-top: var(--space-x2); */
}
.home__right-container__cta-pages {
    border-top: 1px solid var(--primary-light-color);
    margin-top: var(--space-x2);
    padding-top: var(--space-x2);
}
.home__right-container__cta-pages__subtitle {}
.home__right-container__cta-pages__text {
    margin-top: var(--space);
    font-size: calc( var(--space) - 2px ) !important;
}
.home__right-container__cta-pages__new {
    margin-top: var(--space-and-half);
    width: 100%;
}

.home__center-container {
    grid-area: center;
}

.home__center-container.gphome{
    /* grid-column-start: 4; */
    grid-column-start: 3;
    grid-column-end:  11;
    /* margin-right: 70px;
    margin-left: -70px; */

    margin-right: 40px;
    margin-left: calc(calc(100% / 12) - var(--space-and-half) )
}

.home__mobile__left-container__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space-x2) var(--space-x2) var(--space) var(--space-x2);
    border-bottom: 1px solid var(--new-background-color);
    margin-bottom: var(--space);
}
.home__mobile__left-container {
    background-color: var(--white-color);
    position: absolute;
    top: 0;
    z-index: 12;
    animation: slidein 0.5s;
    animation-direction: normal;
    width: 80%;
    height: 100%;
}
.home__mobile__left-container .homepage-shortcut-list__container {
    box-shadow: none;
    padding: 0;
    margin-bottom: 0;
    /* border-bottom: 1px solid #F0F0F0; */
    border-radius: 0;
}

/* .home__mobile__left-container .homepage-pages-shortcuts__list__page-item__data__admin {
    background-color: var(--primary-very-dark-color);
    color: var(--white-color);
    padding: 2px var(--space-half);
}
 */
.home__mobile__left-container__header .icon-x {
    font-size: var(--space-x2);
    color: #1C1B1F;
}
.home__mobile__left-container .homepage-pages-shortcuts__container {
    box-shadow: none;
}
.home__mobile__left-container .homepage-pages-shortcuts__separator {
    border-top: none;
}
.home__mobile__left-container__header img {
    width: 106px;
}


@media screen and ( min-width: 1600px ) {
    .home {
        gap: 60px;
    }
}

@media screen and ( max-width: 1024px ) {
    
    .home {
        grid-template-areas: "center center center center center center center center center center ";
    }
    .home__right-container, .home__left-container {
        display: none;
    }

}

@media screen and ( max-width: 576px ) {
    
    .home {
        margin: 0;
    }

}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */    
    .home {
        display: unset;
        padding-top: 0;
    }

    .home.gphome {
        display: block;
        padding-top: 0;
        gap: 0;
        /* grid-template-columns: 1fr;
        grid-template-rows: repeat(50,1fr);
        grid-template-areas: none; */
    }

    .home__left-container.gphome {
       z-index: 2;
        width: 100vw;
        display: block;
        grid-row-start: 1;
        height: min-content;
        position: fixed;
    } 
    .home__left-container.gphome.womenu {
        display: none;
    }

    .home__center-container.gphome {
        margin-right: 0;
        width: 100vw;
        background-color: var(--new-background-color);
        /* padding: 72px var(--space) var(--space) var(--space); */
        margin-left: 0;

        /* grid-row-start: 2;
        grid-column-start: 1; */
        /* z-index: 10; */        
        display: inline-block;
        position: relative;
        margin-top: 48px;
    }

    .home__center-container.gphome .home-pages{
        display: none;
    }

    .home__center-container.gphome.womenu {
       margin-top: 0;      
    }

    .home__center-container.gphome.womenu .home-pages{
        display: block;
        width: -webkit-fill-available;
    }

    .home__mobile__left-container{
        position: fixed; 
        overflow-y: scroll;
    }
}

@keyframes slidein {
    0%   {left: -100%;}  
    100% {left: 0;}
  }`, "",{"version":3,"sources":["webpack://./src/app/home/views/home/HomeView.styles.css"],"names":[],"mappings":";AACA;IACI,SAAS;IACT,aAAa;IACb,8FAA8F;IAC9F,mFAAmF;IACnF,sCAAsC;IACtC,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,yCAAyC;IACzC,0BAA0B;IAC1B,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,kDAAkD;IAClD,eAAe;IACf,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;AACxC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,iCAAiC;AACrC;AACA;IACI,gDAAgD;IAChD,2BAA2B;IAC3B,4BAA4B;AAChC;AACA,6CAA6C;AAC7C;IACI,wBAAwB;IACxB,gDAAgD;AACpD;AACA;IACI,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,oBAAoB;IACpB;yBACqB;;IAErB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qEAAqE;IACrE,oDAAoD;IACpD,2BAA2B;AAC/B;AACA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;;;;;EAKE;AACF;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;;;AAGA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;;IAEI;QACI,6FAA6F;IACjG;IACA;QACI,aAAa;IACjB;;AAEJ;;AAEA;;IAEI;QACI,SAAS;IACb;;AAEJ;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,MAAM;QACN;;oCAE4B;IAChC;;IAEA;OACG,UAAU;QACT,YAAY;QACZ,cAAc;QACd,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,6CAA6C;QAC7C,0DAA0D;QAC1D,cAAc;;QAEd;+BACuB;QACvB,iBAAiB;QACjB,qBAAqB;QACrB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;OACG,aAAa;IAChB;;IAEA;QACI,cAAc;QACd,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI,MAAM,WAAW,CAAC;IAClB,MAAM,OAAO,CAAC;EAChB","sourcesContent":["\n.home {\n    margin: 0;\n    display: grid;\n    /* grid-template-areas: \"left left left . center center center center center . right right\"; */\n    grid-template-areas: \"left left left center center center center right right right\";\n    grid-template-columns: repeat(10, 1fr);\n    gap: 70px;\n    padding-top: var(--space-and-half);\n}\n\n.home__left-container {\n    grid-area: left;\n    /* padding-left: var(--space-and-half); */\n    padding: 18px var(--space);\n    height: calc(100% - 70px);\n    background: var(--white-color);\n    overflow:auto;\n    overflow:overlay;\n    /* border-radius: 12px; */\n    /* border-bottom: 20px solid var(--white-color); */\n    position: fixed;\n    width: 27%;\n    top: 70px;\n}\n\n.home__left-container::-webkit-scrollbar {\n    display: none; \n}\n\n.home__left-container:hover::-webkit-scrollbar {\n    display: initial;\n}\n\n.home__left-container::-webkit-scrollbar:vertical {\n    width:10px;\n}\n\n.home__left-container::-webkit-scrollbar:horizontal {\n    height: 10px;\n}\n\n.home__left-container::-webkit-scrollbar-thumb {\n    background-color: #797979;\n    border-radius: 20px;\n    border: 2px solid #f1f2f3;\n}\n\n.home__left-container.gphome{\n    grid-column-start: 1;\n    grid-column-end: 3;\n    padding-left: 0;\n    position: fixed;\n    width: 17%;\n    /* overflow: initial; */\n}\n\n.home__right-container {\n    grid-area: right;\n    padding-right: var(--space-and-half);\n}\n.home__right-container__title {\n    margin-top: var(--space-x3);\n}\n.home__right-container__subtitle {\n    margin-top: var(--space-x2);\n}\n.home__right-container__profile-suggestions {\n    margin-top: var(--space-x2);\n}\n.home__right-container__pages-suggestions {\n    /* margin-top: var(--space-x2); */\n}\n.home__right-container__cta-pages {\n    border-top: 1px solid var(--primary-light-color);\n    margin-top: var(--space-x2);\n    padding-top: var(--space-x2);\n}\n.home__right-container__cta-pages__subtitle {}\n.home__right-container__cta-pages__text {\n    margin-top: var(--space);\n    font-size: calc( var(--space) - 2px ) !important;\n}\n.home__right-container__cta-pages__new {\n    margin-top: var(--space-and-half);\n    width: 100%;\n}\n\n.home__center-container {\n    grid-area: center;\n}\n\n.home__center-container.gphome{\n    /* grid-column-start: 4; */\n    grid-column-start: 3;\n    grid-column-end:  11;\n    /* margin-right: 70px;\n    margin-left: -70px; */\n\n    margin-right: 40px;\n    margin-left: calc(calc(100% / 12) - var(--space-and-half) )\n}\n\n.home__mobile__left-container__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--space-x2) var(--space-x2) var(--space) var(--space-x2);\n    border-bottom: 1px solid var(--new-background-color);\n    margin-bottom: var(--space);\n}\n.home__mobile__left-container {\n    background-color: var(--white-color);\n    position: absolute;\n    top: 0;\n    z-index: 12;\n    animation: slidein 0.5s;\n    animation-direction: normal;\n    width: 80%;\n    height: 100%;\n}\n.home__mobile__left-container .homepage-shortcut-list__container {\n    box-shadow: none;\n    padding: 0;\n    margin-bottom: 0;\n    /* border-bottom: 1px solid #F0F0F0; */\n    border-radius: 0;\n}\n\n/* .home__mobile__left-container .homepage-pages-shortcuts__list__page-item__data__admin {\n    background-color: var(--primary-very-dark-color);\n    color: var(--white-color);\n    padding: 2px var(--space-half);\n}\n */\n.home__mobile__left-container__header .icon-x {\n    font-size: var(--space-x2);\n    color: #1C1B1F;\n}\n.home__mobile__left-container .homepage-pages-shortcuts__container {\n    box-shadow: none;\n}\n.home__mobile__left-container .homepage-pages-shortcuts__separator {\n    border-top: none;\n}\n.home__mobile__left-container__header img {\n    width: 106px;\n}\n\n\n@media screen and ( min-width: 1600px ) {\n    .home {\n        gap: 60px;\n    }\n}\n\n@media screen and ( max-width: 1024px ) {\n    \n    .home {\n        grid-template-areas: \"center center center center center center center center center center \";\n    }\n    .home__right-container, .home__left-container {\n        display: none;\n    }\n\n}\n\n@media screen and ( max-width: 576px ) {\n    \n    .home {\n        margin: 0;\n    }\n\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */    \n    .home {\n        display: unset;\n        padding-top: 0;\n    }\n\n    .home.gphome {\n        display: block;\n        padding-top: 0;\n        gap: 0;\n        /* grid-template-columns: 1fr;\n        grid-template-rows: repeat(50,1fr);\n        grid-template-areas: none; */\n    }\n\n    .home__left-container.gphome {\n       z-index: 2;\n        width: 100vw;\n        display: block;\n        grid-row-start: 1;\n        height: min-content;\n        position: fixed;\n    } \n    .home__left-container.gphome.womenu {\n        display: none;\n    }\n\n    .home__center-container.gphome {\n        margin-right: 0;\n        width: 100vw;\n        background-color: var(--new-background-color);\n        /* padding: 72px var(--space) var(--space) var(--space); */\n        margin-left: 0;\n\n        /* grid-row-start: 2;\n        grid-column-start: 1; */\n        /* z-index: 10; */        \n        display: inline-block;\n        position: relative;\n        margin-top: 48px;\n    }\n\n    .home__center-container.gphome .home-pages{\n        display: none;\n    }\n\n    .home__center-container.gphome.womenu {\n       margin-top: 0;      \n    }\n\n    .home__center-container.gphome.womenu .home-pages{\n        display: block;\n        width: -webkit-fill-available;\n    }\n\n    .home__mobile__left-container{\n        position: fixed; \n        overflow-y: scroll;\n    }\n}\n\n@keyframes slidein {\n    0%   {left: -100%;}  \n    100% {left: 0;}\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
